import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <Link to="/" onClick={scrollToTop} className="footer-logo-link">
              <img src="/logo.png" alt="Biltzentech Logo" className="footer-logo-image" />
            </Link>
            <p className="footer-desc">Engineering Intelligence into Business. AI-first product engineering company building production systems.</p>
          </div>
          
          <div className="footer-col">
            <h4 className="footer-title">Company</h4>
            <Link to="/about" onClick={scrollToTop} className="footer-link">About Us</Link>
            <Link to="/careers" onClick={scrollToTop} className="footer-link">Careers</Link>
            <Link to="/case-studies" onClick={scrollToTop} className="footer-link">Case Studies</Link>
            <Link to="/blog" onClick={scrollToTop} className="footer-link">Blog</Link>
          </div>
          
          <div className="footer-col">
            <h4 className="footer-title">Services</h4>
            <Link to="/services" onClick={scrollToTop} className="footer-link">All Services</Link>
            <Link to="/ai-solutions" onClick={scrollToTop} className="footer-link">AI Solutions</Link>
            <Link to="/staffing" onClick={scrollToTop} className="footer-link">Staffing & Teams</Link>
            <Link to="/industries" onClick={scrollToTop} className="footer-link">Industries</Link>
          </div>
          
          <div className="footer-col">
            <h4 className="footer-title">Contact</h4>
            <Link to="/contact" onClick={scrollToTop} className="footer-link">Get in Touch</Link>
            <a href="mailto:contact@biltzentech.com" className="footer-link">contact@biltzentech.com</a>
            <a href="tel:+919740736690" className="footer-link">+91 9740736690</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Biltzentech. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy" className="footer-legal-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-legal-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
